import { BCMSDate, BCMSRecord, BCMSStateManagerCRUD, useBCMSContext, useRoute, useRouteData } from "@bcm-dev/bcms-vite";
import { CenterContentContainer, ContentHeaderView, PageContainer, PageContentView } from 'components/shared';
import Classes, { CustomItemTypeCode, PositivePayCheckFile, PositivePayCheckTemplate, PositivePayCheck, PositivePayImportedChecksUsingTemplateHistory } from "model";
import React from 'react';
import TASPositivePayImportChecksFileImportForm from "./components/TASPositivePayImportChecksFileImportForm";
import TASPositivePayImportChecksTemplateListWidget from "./components/TASPositivePayImportChecksTemplateListWidget";
import "./styles.css";
import "./mobile.css";


/**
 * @function TASPositivePayImportChecksPage
 * @return {React.Component}
 * @exported true
 * @description The TAS Positive Pay Import Checks page.
 */
export default function TASPositivePayImportChecksPage(props) {
  const context = useBCMSContext();
  //const navigate = useRoute();
  BCMSRecord.globalControllerFor(Classes, context);

  const data = { ...getDefaultData(undefined, context), ...props.data ?? {} };
  const ui = { ...getDefaultUI(), ...props.ui ?? {} };

  const controller = (state, setState) => ({
    data: state.data,
    ui: state.ui,

    onCreateNewTemplate: () => {
      //navigate("/tasPositivePayCreateTemplate")
    },

    onChange: prop => value => {
      const crud = BCMSStateManagerCRUD.init(state);

      if(prop === "positivePayCheckFile") {
          value = PositivePayCheckFile.initByID("0")
      }

      if(prop === "selectedTemplate") {
        value = PositivePayCheckTemplate.initByID(value);
      }

      crud.update(["data", prop], value);
      crud.submit(setState);
    }
   });

  return (
    <PageContainer className="tas-positive-pay-import-checks-page" state={ { data, ui } } controller={ controller }>
      <PageContent />
    </PageContainer>
  );
}

export const getDefaultData = () => {

  return {
      positivePayCheckFile: undefined,
      selectedTemplate: undefined,
      templates: PositivePayCheckTemplate.initAll()
      .filter(item => item.id !== undefined)
      .sort((a, b) => {
        return b.id - a.id;
      }),
      // A placeholder instance of history used for captures.
      defaultHistory: PositivePayImportedChecksUsingTemplateHistory.init({
        id: "0",
        template: undefined,
        file: PositivePayCheckFile.initByID("0"),
        confirmationNumber: "39068",
        checks: PositivePayCheck.initAll().reduce((acc, item) => {
          acc.push(item.id);
          return acc;
        }, [])
      }),
      defaultTemplate: PositivePayCheckTemplate.init({ id: "0"})
  };
};

export const getDefaultUI = () => ({
  chooseTemplateSelect: { isActive: false },
  showSuccessHistoryBanner: { isActive: false },
  showNewTemplateBanner: { isActive: false }
});

function PageContent(props) {
  return (
    <PageContentView>
         <CenterContentContainer>
            <ContentHeaderView text="Import Checks" />
            <TASPositivePayImportChecksFileImportForm/>
            <TASPositivePayImportChecksTemplateListWidget/>
        </CenterContentContainer>
    </PageContentView>
  );
}